<template>
  <div class="page page-company-news-list">
    <company-intro-nav-bar />

    <list class="company-news-list"
    />
  </div>
</template>

<script>
  import CompanyIntroNavBar from '@/components/CompanyIntroNavbar';
  import List from '@/pages/Article/components/ArticleList';

  export default {
    name: 'PageArticleList',
    metaInfo: {
      title: '公司动态',
    },
    components: {
      CompanyIntroNavBar,
      List,
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-company-news-list {
    padding-top: @size-small;
  }
  .company-news-list {
    margin-top: @size-small;
  }

</style>
